<template>
  <div :class="['ad-block-plus-enabled']" v-if="$store.state.adBlockPlusEnabled">
    <div :class="['elevation-12', 'pa-4']">
      <h4 :class="['subheading', 'grey--text', 'text--darken-1', 'mb-2']">Please, disable your ad blocker</h4>
      This website is made possible by displaying online advertisements to the visitors.
      To view the content, please, disable your ad blocker,
      then <a href="/" @click.prevent="reload()">refresh</a> the page.</div>
  </div>
</template>
<script>
  export default {
    name: 'AdBlockPlusEnabled',
    methods: {
      reload () {
        window.location.reload()
      }
    }
  }
</script>
<style>
.ad-block-plus-enabled
{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5000;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, .5);
  user-select: none;
}

.ad-block-plus-enabled ~ *
{
  filter: blur(3px);
}

.ad-block-plus-enabled > div
{
  background: #fff;
  width: 50%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>


// WEBPACK FOOTER //
// src/components/AdBlockPlusEnabled.vue